<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <h1 class="m-0 text-dark">{{ $t('profile')}}</h1>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="col-12">
          <button class="btn btn-outline-warning border-0 text-dark text-uppercase" v-bind:class="{'active-background': isProfile}" v-on:click="toggleProfile('profile')">{{ $t('ppProfile')}}</button>
          <button class="ml-5 btn btn-outline-warning border-0 text-dark text-uppercase" v-bind:class="{'active-background': !isProfile}" v-on:click="toggleProfile('bank')">{{ $t('ppBankAccount')}}</button>
          <hr class="bg-dark" />
          <div v-show="isProfile">
            <form>
              <div class="form-group">
                <label for="exampleInputNama">{{ $t('ppName')}}</label>
                <input type="text" class="form-control text-left" v-model="profileForm.name" />
              </div>
              <div class="form-group">
                <label for="exampleInputEmail">Email</label><br>
                <span>{{profileForm.email}}</span>
              </div>
              <div class="form-group">
                <label for="exampleInputHandphone">{{ $t('ppPhone')}}</label>
                <input type="text" class="form-control text-left" v-model="profileForm.phone" />
              </div>
              <div class="form-group">
                <label for="exampleInputNama">{{ $t('ppPass')}}</label>
                <input type="password" class="form-control text-left" v-model="profileForm.password" />
              </div>
              <button
                type="button"
                class="btn btn-success ml-2"
                id="buttons"
                v-on:click="updateUser"
              >{{ $t('ppSave')}}</button>
            </form>
            <h5 class="text-center text-success mt-2">{{dataSuccess}}</h5>
            <h5 class="text-center text-danger">{{dataErr}}</h5>
          </div>

          <div v-show="!isProfile">
            <form>
              <div class="form-group">
                <label for="exampleInputNamaBank">{{ $t('ppBankName')}}</label>
                <input type="email" class="form-control text-left" v-model="bankForm.bankName"/>
              </div>
              <div class="form-group">
                <label for="exampleInputNoRekening">{{ $t('ppBankAccount')}}</label>
                <input type="text" class="form-control text-left"  v-model="bankForm.accountNo"/>
              </div>
              <div class="form-group">
                <label for="exampleInputNamaPemilikRekening">{{ $t('ppOwnerName')}}</label>
                <input type="text" class="form-control text-left" v-model="bankForm.accountName" />
              </div>
            </form>
            <button type="button" class="btn btn-success ml-2" id="buttons" v-on:click="updateBank">{{ $t('ppSave')}}</button>
            <h5 class="text-center text-success mt-2">{{dataSuccess}}</h5>
            <h5 class="text-center text-danger">{{dataErr}}</h5>
          </div>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: "profile",
  components: {},
  data() {
    return {
      profileForm:{
        name: "",
        phone: "",
        email: "",
        password: "",
      },
      bankForm:{
        bankName:"",
        accountNo:"",
        accountName:"",
      },
      isProfile: true,
      dataSuccess: "",
      dataErr: "",
    };
  },
  methods: {
    toggleProfile(profileForm){
      this.isProfile = false
      this.resetMessage()
      if(profileForm == "profile"){
        this.isProfile = true
        this.resetMessage()
      }
    },
    resetMessage(){
      this.dataSuccess = "",
      this.dataErr = ""
    },
    updateUser() {
      let data = this.profileForm
      this.$axios
        .put("api/v1/priority/user/profile", data)
        .then(response => {
          this.dataSuccess = "Data Profile Sukses disimpan";
        })
        
        .catch(error => {
          this.dataErr = "Data Profile Gagal disimpan"
        });
    },
    updateBank(){
      let bankData = this.bankForm
      this.$axios
      .put("api/v1/priority/user/profile-bank", bankData)
      .then(response =>{
        this.dataSuccess = "Data Profile Bank Sukses disimpan";
      })
      .catch(error => {
        this.dataErr = "Data Profile Bank Gagal disimpan"
      })
    }
  },
  created() {
    this.$axios
      .get("/api/v1/priority/user/profile")
      .then(response => {
        this.profileForm.name = response.data.data.name
        this.profileForm.phone = response.data.data.phone
        this.profileForm.email = response.data.data.email
        this.bankForm.accountName = response.data.data.accountName
        this.bankForm.accountNo = response.data.data.accountNo
        this.bankForm.bankName = response.data.data.bankName
      })
      .catch(error => (error));
  }
};
</script>

<style>
#buttons {
  border-radius: 20px;
  width: 80px;
}
.active-background{
  background: #f5c009
}
</style>